import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { List } from '@mui/material';
import { useAtomValue } from 'jotai';
import { activityOutcomesAtom } from '../../Atoms';
import Activity from './Activity';
import ACTIVITY_MAP from '../../Utils/constants/activityItem';
import { compareDates } from '../../Helpers/dates';

function RenderActivityItem(data, props) {
  const intl = useIntl();
  const { id, activityType, outcome } = data || {};
  const { outcomes, selectedCustomer, isOperator, campaignId, ...others } =
    props || {};

  return (
    <Activity
      key={id}
      data={data}
      campaignId={campaignId}
      selectedCustomer={selectedCustomer}
      isOperator={isOperator}
      withoutOutcome={
        (!outcome || outcome === 99 || outcome === 100) &&
        !data.completedOn &&
        compareDates(new Date(data?.scheduledOn ?? null), new Date(), 'smaller')
      }
      recall={activityType === 'CALL' && outcome === 100}
      activityData={{
        id,
        activityType,
        ...ACTIVITY_MAP[activityType](data, intl, outcomes),
      }}
      {...others}
    />
  );
}

const ActivityHistoryList = function ActivityHistoryList({
  maxHeight = null,
  ObserverWrapper = () => {},
  clientPage = false,
  handleOpenDetailsDialog = () => {},
  openReply = () => {},
  selectedCustomer,
  isOperator = false,
  campaignId,
}) {
  const activityOutcomes = useAtomValue(activityOutcomesAtom);
  return (
    <div
      style={{
        overflowY: 'auto',
        maxHeight,
      }}
    >
      <List dense>
        <ObserverWrapper
          Component={(data) =>
            RenderActivityItem(data, {
              handleOpenDetailsDialog,
              isCustomerPage: clientPage,
              openReply,
              outcomes: activityOutcomes[data?.activityType] || [],
              selectedCustomer,
              isOperator,
              campaignId,
            })
          }
        />
      </List>
    </div>
  );
};

ActivityHistoryList.propTypes = {
  maxHeight: PropTypes.string,
  ObserverWrapper: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  clientPage: PropTypes.bool,
  handleOpenDetailsDialog: PropTypes.func,
  openReply: PropTypes.func,
};

export default ActivityHistoryList;
